// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import flag from "../assets/IMG2.png";
// import Sidebar from './Sidebar';
// import {
//     FaEdit,
//     FaPlus,
//     FaClipboardList,
//     FaChevronDown,
//     FaChevronUp
//   } from "react-icons/fa";

// function ManufacturerManager() {
//   const [manufacturers, setManufacturers] = useState([]);
//   const [name, setName] = useState('');
//   const [selectedManufacturerId, setSelectedManufacturerId] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [showForm, setShowForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');


//   // Fetch manufacturers
//   useEffect(() => {
//     async function fetchManufacturers() {
//       try {
//         const response = await axios.get('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer');
//         setManufacturers(response.data);
//       } catch (error) {
//         console.error('Error fetching manufacturers:', error);
//       }
//     }
//     fetchManufacturers();
//   }, []);

  

//   // const handleCreate = async (e) => {
//   //   e.preventDefault();
//   //   const manufacturer = { name }; // Only include the name for creation

//   //   // Validate input
//   //   if (!name) {
//   //     console.error('Invalid input: Name is required.');
//   //     return;
//   //   }

//   //   try {
//   //     // Automatically set the availabilityCount as 0 or based on the car count for this manufacturer
//   //     const response = await axios.post('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer', manufacturer);
//   //     setManufacturers([...manufacturers, response.data]);
//   //     setName('');
//   //   } catch (error) {
//   //     console.error('Error creating manufacturer:', error.response ? error.response.data : error.message);
//   //   }
//   // };
// const handleCreate = async (e) => {
//   e.preventDefault();

//   if (!name.trim()) {
//     setErrorMessage('Name is required.');
//     return;
//   }

//   // Check for duplicate name (case-insensitive)
//   const duplicate = manufacturers.some(
//     (m) => m.name.toLowerCase() === name.trim().toLowerCase()
//   );
//   if (duplicate) {
//     setErrorMessage('Duplicate manufacturer name. Please use a different name.');
//     return;
//   }

//   try {
//     const manufacturer = { name: name.trim() };
//     const response = await axios.post('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer', manufacturer);
//     setManufacturers([...manufacturers, response.data]);
//     setName('');
//     setErrorMessage('');
//     setShowForm(false); // optional: close the popup on success
//   } catch (error) {
//     setErrorMessage(error.response?.data || error.message || 'Error creating manufacturer.');
//   }
// };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     const updatedManufacturer = { manufacturerId: selectedManufacturerId, name };

//     try {
//       await axios.put(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${selectedManufacturerId}`, updatedManufacturer);
//       setManufacturers(manufacturers.map((manufacturer) =>
//         manufacturer.manufacturerId === selectedManufacturerId ? { ...manufacturer, name } : manufacturer
//       ));
//       setIsEditMode(false);
//       setName('');
//       setSelectedManufacturerId(null);
//     } catch (error) {
//       console.error('Error updating manufacturer:', error);
//     }
//   };

//   const handleEdit = (manufacturer) => {
//     setSelectedManufacturerId(manufacturer.manufacturerId);
//     setName(manufacturer.name);
//     setIsEditMode(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${id}`);
//       setManufacturers(manufacturers.filter((manufacturer) => manufacturer.manufacturerId !== id));
//     } catch (error) {
//       console.error('Error deleting manufacturer:', error);
//     }
//   };

//   const handleAvailabilityUpdate = async (id, newCount) => {
//     try {
//       await axios.patch(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/UpdateAvailability/${id}`, newCount);
//       setManufacturers(manufacturers.map((manufacturer) =>
//         manufacturer.manufacturerId === id ? { ...manufacturer, availabilityCount: newCount } : manufacturer
//       ));
//     } catch (error) {
//       console.error('Error updating availability:', error);
//     }
//   };

//   return (
//     <div className="flex h-screen">
//         {/* Sidebar */}
//         <Sidebar />
//          {/* Main Content */}
//          <div className="flex-1 p-6 overflow-auto">
//             <img src={flag} alt="Logo" className="h-10 w-auto mr-2" />
//                 <h2 className="text-2xl font-bold mb-4"></h2>

//                   {/* Popup for Car Form */}
//                   {showForm && (
//     <div 
//         className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50"
//         onClick={() => setShowForm(false)}
//     >
//         <div 
//             className="bg-white shadow-md rounded p-6 relative z-50"
//             onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the form
//         >
//                             <h3 className="text-xl font-bold mb-4">Add New Car</h3>
//                             <form onSubmit={isEditMode ? handleUpdate : handleCreate} className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto">
//         <div className="mb-4">
//           <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
//           {/* <input
//             type="text"
//             id="name"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             required
//             className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
//           /> */}
//           <input
//   type="text"
//   id="name"
//   value={name}
//   onChange={(e) => {
//     setName(e.target.value);
//     if (errorMessage) setErrorMessage('');
//   }}
//   required
//   className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
// />

//         </div>
//         <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 focus:outline-none">
//           {isEditMode ? 'Update Manufacturer' : 'Create Manufacturer'}
//           {errorMessage && (
//   <p className="text-red-600 text-sm mb-3">{errorMessage}</p>
// )}

//         </button>
//       </form>

//                         </div>
//                     </div>
//                 )}


//                 <div className="mt-6 relative"></div>
//                 <div
//        className="relative bg-white lg:w-[90%] w-[100%] lg:mx-3 lg:px-10 lg:py-10 p-5 lg:rounded-tl-[3rem] rounded-lg shadow-xl"
//        style={{
//            backdropFilter: "blur(15px)",
//            boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
//            border: "1px solid rgba(182, 168, 168, 0.3)",
//        }}
//    >

// <div >
//     {/* Plus Icon Button (Top Right) */}
//     <button
//         title="Add New"
//         onClick={() => setShowForm(true)}
//         className="absolute top-3 right-3 bg-blue-500 hover:bg-green-600 rounded-full p-3 text-white text-lg lg:text-2xl"
//     >
//         <FaPlus />
//     </button>

//     <h3 className="text-xl font-bold mb-2">Car List</h3>

//                     <table className="w-full text-sm text-left text-gray-500">
//                         <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//                             <tr className="bg-gray-100">
//                             <th className="px-6 py-3">ManufacturerID</th>
//                             <th className="px-6 py-3">Manufacturer</th>
//                             <th className="px-6 py-3">AvailabilityCount</th>
                            
//                             </tr>
//                         </thead>
//                         {/* <tbody>
//                         {manufacturers.map((manufacturer) => (
//                                 <tr key={manufacturer.manufacturerId} className="border">
//                                      <td className="px-6 py-4 font-medium text-gray-900">{manufacturer.manufacturerId}</td>
                                     

//                                      <td className="px-6 py-4 font-medium text-gray-900">{manufacturer.name}</td>
                                     
//                                      <td className="px-6 py-4">{manufacturer.availabilityCount}</td>
                                     
//                                 </tr>
//                             ))}
//                         </tbody> */}

//                         <tbody>
//   {manufacturers.map((manufacturer) => (
//     <tr key={manufacturer.manufacturerId} className="border">
//       <td className="px-6 py-4 font-medium text-gray-900">{manufacturer.manufacturerId}</td>
//       <td className="px-6 py-4 font-medium text-gray-900">{manufacturer.name}</td>
//       <td className="px-6 py-4 flex items-center justify-between">
//         {manufacturer.availabilityCount}
        
//         {/* Show Edit button only if availabilityCount is 0 */}
//         {manufacturer.availabilityCount === 0 && (
//           <button
//             title="Edit Manufacturer"
//             onClick={() => handleEdit(manufacturer)}
//             className="text-blue-600 hover:text-blue-900 ml-4"
//           >
//             <FaEdit />
//           </button>
//         )}
//       </td>
//     </tr>
//   ))}
// </tbody>

//                     </table>

//    </div>

//       </div>
//       </div>
//       </div>
   
//   );
// }

// export default ManufacturerManager;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import flag from "../assets/IMG2.png";
import Sidebar from './Sidebar';
import {
  FaEdit,
  FaPlus
} from "react-icons/fa";

function ManufacturerManager() {
  const [manufacturers, setManufacturers] = useState([]);
  const [cars, setCars] = useState([]);
  const [name, setName] = useState('');
  const [selectedManufacturerId, setSelectedManufacturerId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Fetch manufacturers and cars on load
  useEffect(() => {
    async function fetchData() {
      try {
        const [manuRes, carsRes] = await Promise.all([
          axios.get('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer'),
          // axios.get('https://carrentalbackend.dockyardsoftware.com/api/Car')
        ]);
        setManufacturers(manuRes.data);
        setCars(carsRes.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    fetchData();
  }, []);

  // Create manufacturer
  const handleCreate = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setErrorMessage('Name is required.');
      return;
    }

    const duplicate = manufacturers.some(m => m.name.toLowerCase() === name.trim().toLowerCase());
    if (duplicate) {
      setErrorMessage('Duplicate manufacturer name. Please use a different name.');
      return;
    }

    try {
      const response = await axios.post('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer', { name: name.trim() });
      setManufacturers([...manufacturers, response.data]);
      setName('');
      setErrorMessage('');
      setShowForm(false);

      window.location.reload();
    } catch (error) {
      setErrorMessage(error.response?.data?.error || error.message || 'Error creating manufacturer.');
    }
  };

  // Update manufacturer
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setErrorMessage('Name is required.');
      return;
    }

    const duplicate = manufacturers.some(
      m => m.name.toLowerCase() === name.trim().toLowerCase() && m.manufacturerId !== selectedManufacturerId
    );
    if (duplicate) {
      setErrorMessage('Duplicate manufacturer name. Please use a different name.');
      return;
    }

    try {
      const updatedManufacturer = {
        manufacturerId: selectedManufacturerId,
        name: name.trim(),
        availabilityCount: manufacturers.find(m => m.manufacturerId === selectedManufacturerId)?.availabilityCount || 0
      };

      await axios.put(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${selectedManufacturerId}`, updatedManufacturer);

      setManufacturers(manufacturers.map(m =>
        m.manufacturerId === selectedManufacturerId ? { ...m, name: name.trim() } : m
      ));
      setIsEditMode(false);
      setName('');
      setSelectedManufacturerId(null);
      setErrorMessage('');
      setShowForm(false);
    } catch (error) {
      setErrorMessage(error.response?.data || error.message || 'Error updating manufacturer.');
    }
  };

  // Handle edit button click
  const handleEdit = (manufacturer) => {
    // Check if manufacturer has linked cars
    const linkedCars = cars.some(car => car.manufacturerId === manufacturer.manufacturerId);

    if (linkedCars) {
      setErrorMessage('Cannot edit manufacturer with linked cars.');
      setTimeout(() => setErrorMessage(''), 3000);
      return;
    }

    setSelectedManufacturerId(manufacturer.manufacturerId);
    setName(manufacturer.name);
    setIsEditMode(true);
    setErrorMessage('');
    setShowForm(true);
  };

  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-6 overflow-auto relative">

        {/* Global error message */}
        {errorMessage && !showForm && (
          <div className="fixed top-5 right-5 bg-red-600 text-white px-4 py-2 rounded shadow z-50">
            {errorMessage}
          </div>
        )}

        <img src={flag} alt="Logo" className="h-10 w-auto mr-2" />

        {/* Popup Form */}
        {showForm && (
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50"
            onClick={() => setShowForm(false)}
          >
            <div
              className="bg-white shadow-md rounded p-6 relative z-50 max-w-lg w-full"
              onClick={e => e.stopPropagation()}
            >
              <h3 className="text-xl font-bold mb-4">{isEditMode ? 'Edit Manufacturer' : 'Add New Manufacturer'}</h3>
              <form onSubmit={isEditMode ? handleUpdate : handleCreate}>
                <div className="mb-4">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                  <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      if (errorMessage) setErrorMessage('');
                    }}
                    required
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                {errorMessage && (
                  <p className="text-red-600 text-sm mb-3">{errorMessage}</p>
                )}
                <button
                  type="submit"
                  className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  {isEditMode ? 'Update Manufacturer' : 'Create Manufacturer'}
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Add Button */}
        <button
          title="Add New"
          onClick={() => {
            setIsEditMode(false);
            setName('');
            setSelectedManufacturerId(null);
            setErrorMessage('');
            setShowForm(true);
          }}
          className="absolute top-3 right-3 bg-blue-500 hover:bg-green-600 rounded-full p-3 text-white text-lg lg:text-2xl"
        >
          <FaPlus />
        </button>

        <h3 className="text-xl font-bold mb-2">Manufacturer List</h3>

        {/* Table */}
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700   bg-gray-200">
            <tr className="bg-gray-100">
              <th className="px-6 py-3 text-center">ManufacturerID</th>
              <th className="px-6 py-3 text-left">Manufacturer</th>
              <th className="px-6 py-3 text-center">AvailabilityCount</th>
              <th className="px-6 py-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {manufacturers.map(manufacturer => (
              <tr key={manufacturer.manufacturerId} className="border">
                <td className="px-6 py-4 font-medium text-gray-900 text-center">{manufacturer.manufacturerId}</td>
                <td className="px-6 py-4 font-medium text-gray-900 text-left">{manufacturer.name}</td>
                <td className="px-6 py-4 text-center">{manufacturer.availabilityCount}</td>
                <td className="px-6 py-4 text-center">
                  <button
                    title="Edit Manufacturer"
                    onClick={() => handleEdit(manufacturer)}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEdit />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ManufacturerManager;
